var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content content--small"},[_c('h1',[_vm._v("Signups")]),_c('ListFirestore',{attrs:{"item-name":"Signup","get-collection":_vm.getSignupsCollection,"order-list":_vm.orderList,"on-reset":_vm.onReset},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var signup = ref.item;
return [_c('SignupListItem',{attrs:{"signup":signup}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }